import React, { useState } from "react";
import content from "./toolkitContent.json";
import "./Toolkit.css";

const assets = `${process.env.PUBLIC_URL || ""}/toolkit`;
const media: Record<string, { file: string; kind: "audio" | "video" }> = {
  "001": { file: "relaxation-with-anchor.wav", kind: "audio" },
  "002": { file: "box-breathing.wav", kind: "audio" },
};

export default function ToolkitView() {
  const [selected, setSelected] = useState("000");
  const tool = content.find((item) => item.id === selected) || content[0];
  const recording = media[tool.id];
  function openTool(id: string) {
    setSelected(id);
    window.scrollTo({ top: 0, behavior: "auto" });
  }
  return (
    <section className="toolkit-shell">
      <div className="toolkit-hero">
        <p className="toolkit-eyebrow">Your personal collection of practical tools</p>
        <h1>Your Toolkit</h1>
        <p className="toolkit-lead">Explore, practise and discover what works for you. Begin with the welcome and safety guidance.</p>
      </div>
      <nav className="toolkit-tool-nav" aria-label="Toolkit tools">
        {content.map((item) => (
          <button key={item.id} type="button" aria-pressed={item.id === tool.id} onClick={() => openTool(item.id)}>
            {item.id === "000" ? "Welcome and safety" : item.title}
          </button>
        ))}
      </nav>
      <article className="toolkit-guidance" key={tool.id}>
        <h2>{tool.title}</h2>
        {tool.blocks.map((block, index) => block.heading
          ? <h3 key={index}>{block.text}</h3>
          : <p className="toolkit-document" key={index}>{block.text}</p>
        )}
        {recording && (
          <section aria-label={recording.kind === "video" ? "Welcome video" : "Guided audio"}>
            <h3>{recording.kind === "video" ? "Watch the welcome video" : "Listen to the guided exercise"}</h3>
            <p>Read the written guidance above before using this recording.</p>
            {recording.kind === "video"
              ? <video className="toolkit-media" controls preload="none" playsInline src={`${assets}/${recording.file}`}>Your browser does not support this video.</video>
              : <audio className="toolkit-media" controls preload="none" controlsList="nodownload" src={`${assets}/${recording.file}`}>Your browser does not support this audio.</audio>}
          </section>
        )}
        <a className="toolkit-resource-link" href={`${assets}/${encodeURIComponent(tool.file)}`} download>Download the written guide (Word)</a>
      </article>
      <p className="toolkit-growing-note">Your Toolkit will grow as more tools become ready to share.</p>
    </section>
  );
}
